import { SearchIdentityResult } from './../../interfaces/self-service/search-identity.interface';
import { defineStore } from 'pinia';
import { AccountServices } from '@/services/store/account.services';
import { JssSearchIdentityRequest } from '@/interfaces/self-service/search-identity.interface';

export const useUsernameRecoveryStore = defineStore('UsernameRecovery', () => {
  const searchIdentities = (request: JssSearchIdentityRequest): Promise<SearchIdentityResult> => {
    return AccountServices.searchIdentities(request);
  };

  const recoverAccountInteraction = async (d365Id: string, oktaId: string = '') => {
    await AccountServices.recoverAccountInteraction(d365Id, oktaId);
  };

  return {
    searchIdentities,
    recoverAccountInteraction,
  };
});
